import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'app/core/services/api.service';
import { UtilService } from 'app/core/services/util.service';

@Component({
    selector: 'resume-campaign-dialog',
    templateUrl: './resume-campaign-dialog.component.html',
    styleUrls: [],
})
export class ResumeCampaignDialogComponent implements OnInit {
    isResume: boolean;
    currentPath: string;
    @Input() activePage: 'campaign' | 'option' = 'campaign';
    @Input() is_master_account : boolean = false;
    @Output() dataEvent = new EventEmitter<boolean>();

    constructor(
        public api: ApiService,
        private util: UtilService,
        private dialog: MatDialog,
        private router: Router
    ) {
        this.currentPath = window.location.pathname;
    }
    ngOnInit(): void {}
    // campaign resume
    resumeCampaign() {
        if (this.isResume) return;
        this.isResume = true;
        this.api.getData(`resume-campaign/${this.api.campaignId}`).subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.isResume = false;
                    this.util.showToast(res.message);
                    if (this.activePage == 'campaign') {
                        this.api.allCampaign.forEach((campaign) => {
                            if (campaign.campaign_id == this.api.campaignId) {
                                campaign.status = 'Live';
                            }
                        });
                        if (this.is_master_account) this.dataEvent.emit(true);
                    } else if (this.activePage == 'option') {
                        if (this.currentPath.includes('/campaign/all')) {
                            this.router.navigate(['/campaign']);
                        } else if (this.currentPath.includes('/campaign-builder')) {
                            this.router.navigate(['/campaign-builder'])
                        }
                    }
                } else {
                    this.isResume = false;
                    this.util.showToast(res.message, true);
                    this.api.allCampaign.forEach((campaign) => {
                        if (campaign.campaign_id == this.api.campaignId) {
                            console.log({campaign})
                            campaign.is_active = campaign?.is_active ? 0 : 1;
                        }
                    });
                }
                this.dialog.closeAll();
            },
            error: (err) => {
                console.log('err', err);
                this.isResume = false;
            },
            complete() {},
        });
    }
}
